import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text, DialogMessage } from '@reservamos/elements';

/**
 * NotWsSandboxWarning component.
 * Render a DialogMessage warning that purchases on this tenant are processed in production,
 * because the tenant does not have a sandbox-type web service.
 * @param {object} props - onDismiss.
 * @param {Function} props.onDismiss - Callback to dismiss the warning dialog.
 */
const NotWsSandboxWarning = ({ onDismiss }) => (
  <DialogMessage
    title="WARNING!"
    primaryButton="Accept"
    onClickPrimary={onDismiss}
    showFade
    dialogType="error"
  >
    <Spacing vertical size="S">
      <Text>
        Purchases you make on this tenant are processed in PRODUCTION, because it does not have a
        sandbox-type web service.
      </Text>
      <Text>If you need to make a purchase, check with the team first.</Text>
    </Spacing>
  </DialogMessage>
);

NotWsSandboxWarning.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default NotWsSandboxWarning;
